import React, { Component } from 'react';
import { Button, CardHeader, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, LinearProgress, Paper, SvgIcon } from '@material-ui/core';

import request from "superagent";
import { blogPlayClientType, plugClientType, url_endpoint, url_s3 } from "../../../config";
import authHeader from "../../Utils/AuthHeader";
import clockIcon from '../../../images/icons/clock_icon.svg'
import dashedClockIcon from '../../../images/icons/dashed_clock_icon.svg'
import downloadIcon from '../../../images/icons/download_icon.svg'
import headsetIcon from '../../../images/icons/headset_icon.svg'
import profileIcon from '../../../images/icons/profile_icon.svg'
import moment from 'moment'

import {
    Budget,
    TotalUsers,
    TasksProgress,
    TotalProfit,
    LatestSales,
    UsersByDevice,
    SharesByNetwork,
    LatestProducts,
    LatestOrders
} from './components';
import TableEpisodios from './components/TableEpisodios';
import LoaderSpinner from '../../../componentes/LoaderSpinner';
import checkLogin from '../../Utils/checkLogin';
import DateRangePickers from './components/DateRangePickers';
import { PlayGraph } from './components/PlayGraph';
import palette from '../../../theme/palette';
import ImageIconBox from '../components/ImageIconBox';
import { ExportToCsv } from 'export-to-csv';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf'
import { element } from 'prop-types';

function getFullMonth(month) {
    const months = [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
    ]

    return months[month]
}

function getItemDate(postcastId, date) {

    let indexOf = -1
    for (let index = 0; index < newListaEpisodios.length; index++) {
        const element = newListaEpisodios[index];
        if (element.data && element.data == date && postcastId == element.id)
            return index;

    }
    return indexOf;
}

function updateCuntElement(item, acao) {
    let id = 0

    listaEpisodios.forEach(element => {

        if (item["postcastId"] == element.id) {
            let indexOf = getItemDate(item["postcastId"], item["dateAcesso"])

            if (indexOf > -1) {

                let itm = newListaEpisodios[indexOf]
                itm[acao] = itm[acao] ? itm[acao] + parseInt(item.count) : parseInt(item.count);
                itm["postcastId"] = item["postcastId"]
                newListaEpisodios[indexOf] = itm
                return;
            } else {
                let newItm = { ...element }
                newItm[acao] = parseInt(item.count)
                newItm['data'] = item["dateAcesso"];
                newListaEpisodios.push(newItm)

                return;
            }
        }
    });

    //item['postcastId'] //item['dateAcesso']
}


var listaEpisodios = []
var newListaEpisodios = []

export default class Dashboard extends Component {

    constructor(props) {
        super(props);



        this.state = {
            dataInicio: moment().startOf('day').toDate().getTime(),
            dataFim: moment().startOf('day').toDate().getTime(),

            dataInicioOldYear: moment().subtract(12, 'month').startOf('day').toDate().getTime(),
            dataFimOldYear: moment().subtract(12, 'month').startOf('day').toDate().getTime(),

            currentPlayTotal: 0,
            yearOldPlayTotal: 0,

            currentSpotifyTotal: 0,
            yearOldSpotifyTotal: 0,

            currentGoogleTotal: 0,
            yearOldGoogleTotal: 0,

            currentItunesTotal: 0,
            yearOldItunesTotal: 0,

            reprodPlayer: [],
            openPlaySpotify: [],
            openPlayItunes: [],
            openPlayGoogle: [],


            currentShareTotal: 0,
            yearOldShareTotal: 0,

            shareFacebook: 0,
            shareLinkedin: 0,
            shareTwitter: 0,
            shareWhatsapp: 0,

            currentDownloadTotal: 0,
            yearOldDownloadTotal: 0,
            listaEpisodios: [],
            episodiosNoPeriodo: [],
            // updateCuntElement: this.updateCuntElement
            loading: false,
            clientName: '',
            clientLogo: '',
            clientType: 0,
            monthlyCharacters: 0,
            charCount: 0,
            monthlyAudios: 0,
            audiosOnMonth: 0,

            currentEmailTotal: 0,
            yearOldEmailTotal: 0,
            mediaMinutos: 0,
            totalMinutosReproduzidos: 0,

            openExportDialog: false,
        };
    }



    async componentDidMount() {
        await checkLogin(false)
        const res = await request.get(url_endpoint + 'cliente/me/').set(authHeader())
        this.setState({ monthlyAudios: res.body.monthlyAudios, audiosOnMonth: res.body.audiosOnMonth, monthlyCharacters: res.body.monthlyCharacters, charCount: res.body.charCount == null ? 0 : parseInt(res.body.charCount), clientType: res.body.clientType, clientName: res.body.nome, clientLogo: res.body.img_logo.includes('digitalocean') ? res.body.img_logo : `${url_s3}${res.body.img_logo}` })
        this.props.setTitulo(`Bem vindo de volta, ${this.state.clientName}`);
        this.getDadosRangeDatas()
    }

    clearValores = () => {
        this.setState({
            currentPlayTotal: 0,
            yearOldPlayTotal: 0,

            currentSpotifyTotal: 0,
            yearOldSpotifyTotal: 0,

            currentGoogleTotal: 0,
            yearOldGoogleTotal: 0,

            reprodPlayer: [],
            openPlaySpotify: [],
            openPlayItunes: [],
            openPlayGoogle: [],

            currentShareTotal: 0,
            yearOldShareTotal: 0,

            shareFacebook: 0,
            shareLinkedin: 0,
            shareTwitter: 0,
            shareWhatsapp: 0,

            mediaMinutos: 0,
        })
    }

    getMinutosReproduzidos = () => {
        let minutosReproduzidos = 0

        if (this.state.clientType == blogPlayClientType) {
            this.state.reprodPlayer.forEach(elem => {
                const actualPod = this.state.episodiosNoPeriodo.find(pod => pod.id = elem.postcastId)
                minutosReproduzidos += (actualPod.minutos) * elem.count
            })

            this.state.openPlaySpotify.forEach(elem => {
                const actualPod = this.state.episodiosNoPeriodo.find(pod => pod.id = elem.postcastId)
                minutosReproduzidos += (actualPod.minutos) * elem.count
            })

            this.state.openPlayGoogle.forEach(elem => {
                const actualPod = this.state.episodiosNoPeriodo.find(pod => pod.id = elem.postcastId)
                minutosReproduzidos += (actualPod.minutos) * elem.count
            })

            this.state.openPlayItunes.forEach(elem => {
                const actualPod = this.state.episodiosNoPeriodo.find(pod => pod.id = elem.postcastId)
                minutosReproduzidos += (actualPod.minutos) * elem.count
            })
        }

        if (this.state.clientType == plugClientType) {
            this.state.reprodPlayer.forEach(elem => {
                const actualPod = this.state.episodiosNoPeriodo.find(pod => pod.id = elem.postcastId)
                minutosReproduzidos += Math.floor(((actualPod.seconds) * elem.count) / 60)
            })

            this.state.openPlaySpotify.forEach(elem => {
                const actualPod = this.state.episodiosNoPeriodo.find(pod => pod.id = elem.postcastId)
                minutosReproduzidos += Math.floor(((actualPod.seconds) * elem.count) / 60)
            })

            this.state.openPlayGoogle.forEach(elem => {
                const actualPod = this.state.episodiosNoPeriodo.find(pod => pod.id = elem.postcastId)
                minutosReproduzidos += Math.floor(((actualPod.seconds) * elem.count) / 60)
            })

            this.state.openPlayItunes.forEach(elem => {
                const actualPod = this.state.episodiosNoPeriodo.find(pod => pod.id = elem.postcastId)
                minutosReproduzidos += Math.floor(((actualPod.seconds) * elem.count) / 60)
            })
        }

        this.setState({ totalMinutosReproduzidos: minutosReproduzidos })
    }

    getDadosRangeDatas = async () => {

        this.setState({ loading: true })
        listaEpisodios = []
        this.clearValores();

        const res = await request.get(url_endpoint + "podcast/all/").set(authHeader());

        const noPeriodo = []
        let minutosReproduzidos = 0;
        res.body.forEach(element => {
            listaEpisodios.push({ id: element.id, titulo: element.titulo, createdAt: element.createdAt, minutos: element.minutos, seconds: element.seconds });
            const actualTime = new Date(element.createdAt).getTime()
            if (actualTime >= this.state.dataInicio && actualTime <= this.state.dataFim) {
                console.log('no periodo')
                noPeriodo.push({ id: element.id, titulo: element.titulo, createdAt: element.createdAt, minutos: element.minutos, seconds: element.seconds })
            }
        });

        //listaEpisodios

        this.setState({ listaEpisodios: listaEpisodios, episodiosNoPeriodo: noPeriodo })

        //PLAY
        //current date
        request.get(url_endpoint + 'playerview/range/' + this.state.dataInicio + '/' + this.state.dataFim + '/email/').set(authHeader())
            .end((err, res) => {

                let currentEmailTotal = 0;
                let lista = [];
                if (res.body != null) {
                    res.body.forEach(function (childSnapshot) {
                        currentEmailTotal += parseInt(childSnapshot['count']);

                        lista.push(childSnapshot)
                    });
                }

                this.setState({ currentEmailTotal: currentEmailTotal })
            });

        request.get(url_endpoint + 'playerview/range/' + this.state.dataInicio + '/' + this.state.dataFim + '/play/').set(authHeader())
            .end((err, res) => {

                let currentPlayTotal = 0;
                let lista = [];
                res.body.forEach(function (childSnapshot) {
                    currentPlayTotal += parseInt(childSnapshot['count']);

                    updateCuntElement(childSnapshot, 'play')
                    lista.push(childSnapshot)
                });


                this.setState({ currentPlayTotal: currentPlayTotal, reprodPlayer: lista })
                lista.forEach(elem => {
                    const actualPod = listaEpisodios.find(pod => pod.id == elem.postcastId)
                    if (actualPod) {
                        if (this.state.clientType == blogPlayClientType) {
                            minutosReproduzidos = minutosReproduzidos + (actualPod.minutos * elem.count)
                        }
                        if (this.state.clientType == plugClientType) {
                            minutosReproduzidos = minutosReproduzidos + Math.floor(((actualPod.seconds) * elem.count) / 60)
                        }
                    }
                })
            });

        //old date
        request.get(url_endpoint + 'playerview/range/' + this.state.dataInicioOldYear + '/' + this.state.dataFimOldYear + '/play/').set(authHeader())
            .end((err, res) => {

                let currentPlayTotal = 0;
                res.body.forEach(function (childSnapshot) {
                    currentPlayTotal += parseInt(childSnapshot['count']);
                });

                this.setState({ yearOldPlayTotal: currentPlayTotal })
            });
        //PLAY


        request.get(url_endpoint + 'playerview/range/' + this.state.dataInicioOldYear + '/' + this.state.dataFimOldYear + '/email/').set(authHeader())
            .end((err, res) => {

                let currentEmailTotal = 0;
                res.body.forEach(function (childSnapshot) {
                    currentEmailTotal += parseInt(childSnapshot['count']);
                });

                this.setState({ yearOldEmailTotal: currentEmailTotal })
            });


        //SPOTIFY
        //current date
        request.get(url_endpoint + 'playerview/range/' + this.state.dataInicio + '/' + this.state.dataFim + '/agregador_spotify/').set(authHeader())
            .end((err, res) => {

                let currentPlayTotal = 0;
                let lista = []
                res.body.forEach(function (childSnapshot) {
                    currentPlayTotal += parseInt(childSnapshot['count']);
                    lista.push(childSnapshot)

                    updateCuntElement(childSnapshot, 'spotify')

                });

                this.setState({ currentSpotifyTotal: currentPlayTotal, openPlaySpotify: lista })
                lista.forEach(elem => {
                    const actualPod = listaEpisodios.find(pod => pod.id == elem.postcastId)
                    if (actualPod) {
                        if (this.state.clientType == blogPlayClientType) {
                            minutosReproduzidos = minutosReproduzidos + (actualPod.minutos * elem.count)
                        }
                        if (this.state.clientType == plugClientType) {
                            minutosReproduzidos = minutosReproduzidos + Math.floor(((actualPod.seconds) * elem.count) / 60)
                        }
                    }
                })
            });
        //old date
        request.get(url_endpoint + 'playerview/range/' + this.state.dataInicioOldYear + '/' + this.state.dataFimOldYear + '/agregador_spotify/').set(authHeader())
            .end((err, res) => {

                let currentPlayTotal = 0;
                res.body.forEach(function (childSnapshot) {
                    currentPlayTotal += parseInt(childSnapshot['count']);
                });

                this.setState({ yearOldSpotifyTotal: currentPlayTotal })
            });
        //SPOTIFY



        //ITUNES
        //current date
        request.get(url_endpoint + 'playerview/range/' + this.state.dataInicio + '/' + this.state.dataFim + '/agregador_itunes/').set(authHeader())
            .end((err, res) => {

                let currentPlayTotal = 0;
                let lista = []
                res.body.forEach(function (childSnapshot) {
                    currentPlayTotal += parseInt(childSnapshot['count']);
                    lista.push(childSnapshot)

                    updateCuntElement(childSnapshot, 'itunes')
                });

                this.setState({ currentItunesTotal: currentPlayTotal, openPlayItunes: lista })
                lista.forEach(elem => {
                    const actualPod = listaEpisodios.find(pod => pod.id == elem.postcastId)
                    if (actualPod) {
                        if (this.state.clientType == blogPlayClientType) {
                            minutosReproduzidos = minutosReproduzidos + (actualPod.minutos * elem.count)
                        }
                        if (this.state.clientType == plugClientType) {
                            minutosReproduzidos = minutosReproduzidos + Math.floor(((actualPod.seconds) * elem.count) / 60)
                        }
                    }
                })
            });

        //old date
        request.get(url_endpoint + 'playerview/range/' + this.state.dataInicioOldYear + '/' + this.state.dataFimOldYear + '/agregador_itunes/').set(authHeader())
            .end((err, res) => {

                let currentPlayTotal = 0;

                res.body.forEach(function (childSnapshot) {
                    currentPlayTotal += parseInt(childSnapshot['count']);

                });

                this.setState({ yearOldItunesTotal: currentPlayTotal })
            });
        //ITUNES


        //GOOGLE
        //current date
        request.get(url_endpoint + 'playerview/range/' + this.state.dataInicio + '/' + this.state.dataFim + '/agregador_google/').set(authHeader())
            .end((err, res) => {

                let currentPlayTotal = 0;
                let lista = []
                res.body.forEach(function (childSnapshot) {
                    currentPlayTotal += parseInt(childSnapshot['count']);
                    lista.push(childSnapshot)

                    updateCuntElement(childSnapshot, 'google')
                });

                this.setState({ currentGoogleTotal: currentPlayTotal, openPlayGoogle: lista })
                lista.forEach(elem => {
                    const actualPod = listaEpisodios.find(pod => pod.id == elem.postcastId)
                    if (actualPod) {
                        if (this.state.clientType == blogPlayClientType) {
                            minutosReproduzidos = minutosReproduzidos + (actualPod.minutos * elem.count)
                        }
                        if (this.state.clientType == plugClientType) {
                            minutosReproduzidos = minutosReproduzidos + Math.floor(((actualPod.seconds) * elem.count) / 60)
                        }
                    }
                })
                console.log('minutosReproduzidos', minutosReproduzidos)
                console.log('currentPlayTotal', currentPlayTotal)
                this.setState({ totalMinutosReproduzidos: minutosReproduzidos, mediaMinutos: Math.round(minutosReproduzidos / this.state.currentPlayTotal) })
            });

        //old date
        request.get(url_endpoint + 'playerview/range/' + this.state.dataInicioOldYear + '/' + this.state.dataFimOldYear + '/agregador_google/').set(authHeader())
            .end((err, res) => {

                let currentPlayTotal = 0;
                res.body.forEach(function (childSnapshot) {
                    currentPlayTotal += parseInt(childSnapshot['count']);
                });

                this.setState({ yearOldGooleTotal: currentPlayTotal })
            });
        //ITUNES

        //###--Share---------------------------------------------- 
        //share_facebook
        //current date
        request.get(url_endpoint + 'playerview/range/' + this.state.dataInicio + '/' + this.state.dataFim + '/share_facebook/').set(authHeader())
            .end((err, res) => {

                let currentTotal = 0;
                res.body.forEach(function (childSnapshot) {
                    currentTotal += parseInt(childSnapshot['count']);
                });

                this.setState({ currentShareTotal: this.state.currentShareTotal + currentTotal, shareFacebook: currentTotal })
            });

        //old date
        request.get(url_endpoint + 'playerview/range/' + this.state.dataInicioOldYear + '/' + this.state.dataFimOldYear + '/share_facebook/').set(authHeader())
            .end((err, res) => {

                let currentTotal = 0;
                res.body.forEach(function (childSnapshot) {
                    currentTotal += parseInt(childSnapshot['count']);
                });

                this.setState({ yearOldShareTotal: this.state.yearOldShareTotal + currentTotal })
            });


        //share_linkedin
        //current date
        request.get(url_endpoint + 'playerview/range/' + this.state.dataInicio + '/' + this.state.dataFim + '/share_linkedin/').set(authHeader())
            .end((err, res) => {

                let currentTotal = 0;
                res.body.forEach(function (childSnapshot) {
                    currentTotal += parseInt(childSnapshot['count']);
                });

                this.setState({ currentShareTotal: this.state.currentShareTotal + currentTotal, shareLinkedin: currentTotal })
            });

        //old date
        request.get(url_endpoint + 'playerview/range/' + this.state.dataInicioOldYear + '/' + this.state.dataFimOldYear + '/share_linkedin/').set(authHeader())
            .end((err, res) => {

                let currentTotal = 0;
                res.body.forEach(function (childSnapshot) {
                    currentTotal += parseInt(childSnapshot['count']);
                });

                this.setState({ yearOldShareTotal: this.state.yearOldShareTotal + currentTotal })
            });

        //share_twitter
        //current date
        request.get(url_endpoint + 'playerview/range/' + this.state.dataInicio + '/' + this.state.dataFim + '/share_twitter/').set(authHeader())
            .end((err, res) => {

                let currentTotal = 0;
                res.body.forEach(function (childSnapshot) {
                    currentTotal += parseInt(childSnapshot['count']);
                });

                this.setState({ currentShareTotal: this.state.currentShareTotal + currentTotal, shareTwitter: currentTotal })
            });

        //old date
        request.get(url_endpoint + 'playerview/range/' + this.state.dataInicioOldYear + '/' + this.state.dataFimOldYear + '/share_twitter/').set(authHeader())
            .end((err, res) => {

                let currentTotal = 0;
                res.body.forEach(function (childSnapshot) {
                    currentTotal += parseInt(childSnapshot['count']);
                });

                this.setState({ yearOldShareTotal: this.state.yearOldShareTotal + currentTotal })
            });


        //share_whatsapp
        //current date
        request.get(url_endpoint + 'playerview/range/' + this.state.dataInicio + '/' + this.state.dataFim + '/share_whatsapp/').set(authHeader())
            .end((err, res) => {

                let currentTotal = 0;
                res.body.forEach(function (childSnapshot) {
                    currentTotal += parseInt(childSnapshot['count']);
                });

                this.setState({ currentShareTotal: this.state.currentShareTotal + currentTotal, shareWhatsapp: currentTotal })
            });

        //old date
        request.get(url_endpoint + 'playerview/range/' + this.state.dataInicioOldYear + '/' + this.state.dataFimOldYear + '/share_whatsapp/').set(authHeader())
            .end((err, res) => {

                let currentTotal = 0;
                res.body.forEach(function (childSnapshot) {
                    currentTotal += parseInt(childSnapshot['count']);
                });

                this.setState({ yearOldShareTotal: this.state.yearOldShareTotal + currentTotal })
            });


        //download
        //current date
        request.get(url_endpoint + 'playerview/range/' + this.state.dataInicio + '/' + this.state.dataFim + '/download/').set(authHeader())
            .end((err, res) => {

                let currentTotal = 0;
                res.body.forEach(function (childSnapshot) {
                    currentTotal += parseInt(childSnapshot['count']);
                    updateCuntElement(childSnapshot, 'download')
                });

                this.setState({ currentDownloadTotal: currentTotal })
            });

        //old date
        request.get(url_endpoint + 'playerview/range/' + this.state.dataInicioOldYear + '/' + this.state.dataFimOldYear + '/download/').set(authHeader())
            .end((err, res) => {

                let currentTotal = 0;
                res.body.forEach(function (childSnapshot) {
                    currentTotal += parseInt(childSnapshot['count']);
                });

                this.setState({ yearOldDownloadTotal: this.state.yearOldDownloadTotal + currentTotal })
            });

        this.setState({ loading: false })

    }


    changerangedata = async (startDate, endDate) => {

        let dataInicio = moment(startDate).startOf('day').toDate().getTime();
        let dataFim = moment(endDate).startOf('day').toDate().getTime();

        const OldYearStartDate = new Date(moment(startDate).subtract(12, 'month').startOf('day')).getTime()
        const OldYearEndDate = new Date(moment(endDate).subtract(12, 'month').startOf('day')).getTime()

        await this.setState({ dataInicio: dataInicio, dataFim: dataFim, dataInicioOldYear: OldYearStartDate, dataFimOldYear: OldYearEndDate });
        this.getDadosRangeDatas();

    }

    removeShadowsFromElement(element) {
        if (element.style != null && element.style != undefined) {
            element.style.boxShadow = 'none'
        }

        for (let i = 0; i < element.childNodes.length; i++) {
            const actualChild = element.childNodes[i];
            if (actualChild.style != null && actualChild.style != undefined) {
                actualChild.style.boxShadow = 'none'
            }

            if (actualChild.childNodes.length != 0) {
                this.removeShadowsFromElement(actualChild)
            }
        }
    }

    resetShadowsFromElement(element) {
        if (element.style != null && element.style != undefined) {
            element.style.boxShadow = ''
        }

        for (let i = 0; i < element.childNodes.length; i++) {
            const actualChild = element.childNodes[i];
            if (actualChild.style != null && actualChild.style != undefined) {
                actualChild.style.boxShadow = ''
            }

            if (actualChild.childNodes.length != 0) {
                this.removeShadowsFromElement(actualChild)
            }
        }
    }

    async getImageFromElement(element) {
        this.removeShadowsFromElement(element)

        const data = await html2canvas(element);
        const img = data.toDataURL("image/png");

        this.resetShadowsFromElement(element)

        return img
    }

    async printDocument() {
        try {
            // Vertical
            // const pdf = new jsPDF("portrait", "pt", "a4");
            // const pdfWidth = pdf.internal.pageSize.getWidth();
            // const pdfHeight = pdf.internal.pageSize.getHeight()

            // const graphsHeightValue = this.state.clientType == blogPlayClientType ? 0.33 : 0.5

            // const playGraphElement = document.querySelector('#playgraph')
            // const playGraphImg = await this.getImageFromElement(playGraphElement);
            // pdf.addImage(playGraphImg, "PNG", 0, 0, (pdfWidth), (pdfHeight * graphsHeightValue));

            // const shareGraphElement = document.querySelector('#sharegraph')
            // const shareGraphImg = await this.getImageFromElement(shareGraphElement);
            // pdf.addImage(shareGraphImg, "PNG", 0, (pdfHeight * graphsHeightValue) * 1, (pdfWidth) * (this.state.clientType == blogPlayClientType ? 0.5 : 1), (pdfHeight * graphsHeightValue));

            // if (this.state.clientType == blogPlayClientType) {
            //     const userGraphElement = document.querySelector('#usergraph')
            //     const userGraphImg = await this.getImageFromElement(userGraphElement);
            //     pdf.addImage(userGraphImg, "PNG", 0, (pdfHeight * graphsHeightValue) * 2, (pdfWidth) * 0.5, (pdfHeight * graphsHeightValue));
            // }

            // pdf.addPage()
            // const cardsElements = await document.querySelectorAll('.data-card')
            // for (let i = 0; i < cardsElements.length; i++) {
            //     const cardElement = cardsElements[i]
            //     const cardImg = await this.getImageFromElement(cardElement);
            //     pdf.addImage(cardImg, "PNG", pdfWidth * 0.25, (pdfHeight * 0.2) * i, pdfWidth * 0.5, (pdfHeight * 0.2));
            // }

            // Horizontal
            // const pdf = new jsPDF("landscape", "pt", "a4");
            // const pdfWidth = pdf.internal.pageSize.getWidth();
            // const pdfHeight = pdf.internal.pageSize.getHeight()

            // const graphsWidthValue = this.state.clientType == blogPlayClientType ? 0.33 : 0.5

            // const playGraphElement = document.querySelector('#playgraph')
            // const playGraphImg = await this.getImageFromElement(playGraphElement);
            // pdf.addImage(playGraphImg, "PNG", 0, 0, (pdfWidth * graphsWidthValue), (pdfHeight * .8 ));

            // const shareGraphElement = document.querySelector('#sharegraph')
            // const shareGraphImg = await this.getImageFromElement(shareGraphElement);
            // pdf.addImage(shareGraphImg, "PNG", (pdfWidth * graphsWidthValue) * 1, 0, (pdfWidth * graphsWidthValue), (pdfHeight * .8));

            // if (this.state.clientType == blogPlayClientType) {
            //     const userGraphElement = document.querySelector('#usergraph')
            //     const userGraphImg = await this.getImageFromElement(userGraphElement);
            //     pdf.addImage(userGraphImg, "PNG", (pdfWidth * graphsWidthValue) * 2, 0, (pdfWidth) * 0.33, (pdfHeight * .8 ));
            // }

            // pdf.addPage()
            // const cardsElements = document.querySelectorAll('.data-card')
            // for (let i = 0; i < cardsElements.length; i++) {
            //     const cardElement = cardsElements[i]
            //     const cardImg = await this.getImageFromElement(cardElement);
            //     pdf.addImage(cardImg, "PNG", (pdfWidth * 0.2) * i, 0, pdfWidth * 0.2, (pdfHeight * 0.2));
            // }


            const pdf = new jsPDF("portrait", "pt", "a4");
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight()

            const graphsHeightValue = 0.47

            const playGraphElement = document.querySelector('#playgraph')
            const playGraphImg = await this.getImageFromElement(playGraphElement);
            pdf.addImage(playGraphImg, "PNG", 0, 0, (pdfWidth), (pdfHeight * graphsHeightValue));

            const shareGraphElement = document.querySelector('#sharegraph')
            const shareGraphImg = await this.getImageFromElement(shareGraphElement);
            pdf.addImage(shareGraphImg, "PNG", 0, (pdfHeight * graphsHeightValue) * 1, (pdfWidth) * (this.state.clientType == blogPlayClientType ? 0.5 : 1), (pdfHeight * graphsHeightValue));

            if (this.state.clientType == blogPlayClientType) {
                const userGraphElement = document.querySelector('#usergraph')
                const userGraphImg = await this.getImageFromElement(userGraphElement);
                pdf.addImage(userGraphImg, "PNG", pdfWidth * 0.5, (pdfHeight * graphsHeightValue) * 1, (pdfWidth) * 0.5, (pdfHeight * graphsHeightValue));
            }

            pdf.addPage()
            const cardsElements = document.querySelectorAll('.data-card')
            const cardsWidthFactor = 0.31
            const cardsHeightFactor = 0.1
            for (let i = 0; i < cardsElements.length; i++) {
                const cardElement = cardsElements[i]
                const cardImg = await this.getImageFromElement(cardElement);
                if (i < 3) {
                    pdf.addImage(cardImg, "PNG", ((pdfWidth * i) * cardsWidthFactor), 20, pdfWidth * cardsWidthFactor, (pdfHeight * cardsHeightFactor));
                } else {
                    pdf.addImage(cardImg, "PNG", ((pdfWidth * (i - 3)) * cardsWidthFactor) + pdfWidth * cardsWidthFactor, (pdfHeight * cardsHeightFactor) + 20, pdfWidth * cardsWidthFactor, (pdfHeight * cardsHeightFactor));
                }
            }

            pdf.save(`relatorio_blogplay_${moment().format('DD/MM/YYYY HH:mm')}.pdf`);
        } catch (e) {
            console.log(e)
        }
    }

    async exportCSV() {
        this.setState({ loading: true })
        const options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: false,
            title: `Exportação de dados blogplay (Período de ${moment(this.state.dataInicio).format('DD/MM/YYYY')} à ${moment(this.state.dataFim).format('DD/MM/YYYY')})`,
            showTitle: true,
            headers: ['Indicador', 'Valor'],
            filename: `Exportação Blogplay ${moment().format('DD/MM/YYYY HH:mm')}`
        };

        let data = [['', '']]

        data.push(['Reproduções', this.state.currentPlayTotal])

        data.push(['Compartilhamentos Totais', this.state.currentShareTotal])
        data.push(['Compartilhamentos Whatsapp', this.state.shareWhatsapp])
        data.push(['Compartilhamentos Linkedin', this.state.shareLinkedin])
        data.push(['Compartilhamentos Facebook', this.state.shareFacebook])
        data.push(['Compartilhamentos Twitter', this.state.shareTwitter])

        data.push(['Leads', this.state.currentEmailTotal])
        data.push(['Total de downloads', this.state.currentDownloadTotal])
        data.push(['Total de minutos', this.state.totalMinutosReproduzidos])
        data.push(['Média de minutos', this.state.mediaMinutos])

        if (this.state.clientType == blogPlayClientType) {
            data.push(['Redirecionamentos Totais', (this.state.currentSpotifyTotal + this.state.currentItunesTotal + this.state.currentGoogleTotal)])
            data.push(['Redirecionamentos Spotify', this.state.currentSpotifyTotal])
            data.push(['Redirecionamentos Itunes', this.state.currentItunesTotal])
            data.push(['Redirecionamentos Google', this.state.currentGoogleTotal])
        }

        const csvExporter = new ExportToCsv(options);
        await csvExporter.generateCsv(data);
        this.setState({ loading: false })
    }

    render() {
        return (

            <div>

                {this.state.loading &&
                    <LoaderSpinner />
                }

                <Dialog
                    open={this.state.openExportDialog}
                    onClose={() => {
                        this.setState({ openExportDialog: false });
                    }}
                >
                    <DialogTitle>
                        <span style={{ 'color': palette.primary.main, fontSize: '20px' }}>Em que formato deseja exportar os dados?</span>
                    </DialogTitle>
                    <DialogContent>
                        <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', justifyContent: 'space-around' }}>
                            <Button variant='contained' color='primary' onClick={async () => {
                                await this.exportCSV()
                                this.setState({ openExportDialog: false })
                            }}>CSV</Button>
                            <Button variant='contained' color='primary' onClick={async () => {
                                await this.printDocument()
                                this.setState({ openExportDialog: false })
                            }}>PDF</Button>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <span onClick={() => {
                            this.setState({ openExportDialog: false })
                        }} style={{ cursor: 'pointer', 'color': palette.error.main, fontSize: '16px' }}>
                            {"Cancelar"}
                        </span>
                    </DialogActions>
                </Dialog>

                <h2 style={{ color: '#f2a404' }}>Principais Contadores</h2>
                <Divider style={{ margin: '10px 0' }}></Divider>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'baseline', color: '#f2a404', marginBottom: '5px' }}>
                        <span style={{ fontSize: '16px' }}>Filtrar Dados:</span>
                        <CardHeader action={<DateRangePickers changerangedata={this.changerangedata}></DateRangePickers>} />
                    </div>
                    {/* <Button variant='contained' color='primary' onClick={() => this.setState({ openExportDialog: true })}>Exportar Relatório</Button> */}
                    <Button variant='contained' color='primary' onClick={() => this.exportCSV()}>Exportar Relatório</Button>
                </div>

                <Grid
                    container
                    spacing={4}
                >
                    <Grid
                        id='playgraph'
                        style={{ height: 500 }}
                        item
                        lg={this.state.clientType == blogPlayClientType ? 6 : 7}
                        md={this.state.clientType == blogPlayClientType ? 6 : 7}
                        xl={this.state.clientType == blogPlayClientType ? 6 : 7}
                        xs={12}
                    >

                        {/* <LatestSales changerangedata={this.changerangedata}
                            reproducoes={{ player: this.state.reprodPlayer, spotify: this.state.openPlaySpotify, itunes: this.state.openPlayItunes, google: this.state.openPlayGoogle }} /> */}
                        <PlayGraph id='playgraph' currentTotal={this.state.currentPlayTotal} oldTotal={this.state.yearOldPlayTotal} playsData={this.state.reprodPlayer}></PlayGraph>
                    </Grid>

                    <Grid
                        id='sharegraph'
                        style={{ height: 500 }}
                        item
                        lg={this.state.clientType == blogPlayClientType ? 3 : 5}
                        md={this.state.clientType == blogPlayClientType ? 3 : 5}
                        xl={this.state.clientType == blogPlayClientType ? 3 : 5}
                        xs={12}
                    >
                        <SharesByNetwork currentTotal={this.state.currentShareTotal} oldTotal={this.state.yearOldShareTotal} whatsapp={this.state.shareWhatsapp} facebook={this.state.shareFacebook} linkedin={this.state.shareLinkedin} twitter={this.state.shareTwitter} />
                    </Grid>

                    {this.state.clientType == blogPlayClientType && <Grid
                        id='usergraph'
                        item
                        lg={3}
                        md={3}
                        xl={3}
                        xs={12}
                    >
                        <UsersByDevice id='usergraph' oldGoogle={this.state.yearOldGoogleTotal} oldSpotify={this.state.yearOldSpotifyTotal} oldItunes={this.state.yearOldItunesTotal} reproducoes={{ player: this.state.currentPlayTotal, spotify: this.state.currentSpotifyTotal, itunes: this.state.currentItunesTotal, google: this.state.currentGoogleTotal }} />
                    </Grid>}

                    <Grid
                        item
                        lg={12}
                        md={12}
                        xl={12}
                        xs={12}
                    >
                        <div id='data-cards' style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            flexWrap: 'wrap',
                            rowGap: '15px',
                        }}>
                            <Paper className='data-card' style={{
                                position: 'relative',
                                width: '18%',
                                minWidth: '200px',
                                padding: '10px 20px',
                                color: 'grey',
                                textAlign: 'start',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                justifyContent: 'center'
                            }}>
                                <ImageIconBox style={{ position: 'absolute', top: '10px', right: '15px' }} src={profileIcon}></ImageIconBox>
                                <div style={{ width: '100%', borderLeft: `3px ${palette.primary.main} solid`, padding: '5px 7px' }}>
                                    <h3 style={{ fontWeight: '500', paddingRight: '15px' }}>Leads</h3>
                                    <h1 style={{ marginTop: '5px' }}>{this.state.currentEmailTotal}</h1>
                                </div>
                                <h3 style={{ marginTop: '5px', color: 'lightgrey' }}>Número de contatos capturados</h3>
                            </Paper>
                            <Paper
                                className='data-card' style={{
                                    position: 'relative',
                                    width: '18%',
                                    minWidth: '200px',
                                    padding: '10px 20px',
                                    color: 'grey',
                                    textAlign: 'start',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start',
                                    justifyContent: 'center',
                                }}>
                                <ImageIconBox style={{ position: 'absolute', top: '10px', right: '15px' }} src={headsetIcon}></ImageIconBox>
                                <div style={{ width: '100%', borderLeft: `3px ${palette.primary.main} solid`, padding: '5px 7px' }}>
                                    <h3 style={{ fontWeight: '500', paddingRight: '15px' }}>Reproduções</h3>
                                    <h1 style={{ marginTop: '5px' }}>{this.state.currentPlayTotal}</h1>
                                </div>
                                <h3 style={{ marginTop: '5px', color: 'lightgrey' }}>Número de vezes que seu conteúdo foi reproduzido</h3>
                            </Paper>
                            <Paper className='data-card' style={{
                                position: 'relative',
                                width: '18%',
                                minWidth: '200px',
                                padding: '10px 20px',
                                color: 'grey',
                                textAlign: 'start',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                justifyContent: 'center',
                            }}>
                                <ImageIconBox style={{ position: 'absolute', top: '10px', right: '15px' }} src={downloadIcon}></ImageIconBox>
                                <div style={{ borderLeft: `3px ${palette.primary.main} solid`, padding: '5px 7px' }}>
                                    <h3 style={{ fontWeight: '500', paddingRight: '15px' }}>Total de downloads</h3>
                                    <h1 style={{ marginTop: '5px' }}>{this.state.currentDownloadTotal}</h1>
                                </div>
                                <h3 style={{ marginTop: '5px', color: 'lightgrey' }}>Número de vezes em que seu conteúdo foi baixado</h3>
                            </Paper>
                            <Paper className='data-card' style={{
                                position: 'relative',
                                width: '18%',
                                minWidth: '200px',
                                padding: '10px 20px',
                                color: 'grey',
                                textAlign: 'start',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                justifyContent: 'center'
                            }}>
                                <ImageIconBox style={{ position: 'absolute', top: '10px', right: '15px' }} src={clockIcon}></ImageIconBox>
                                <div style={{ borderLeft: `3px ${palette.primary.main} solid`, padding: '5px 7px' }}>
                                    <h3 style={{ fontWeight: '500', paddingRight: '15px' }}>Total de minutos</h3>
                                    <h1 style={{ marginTop: '5px' }}>{this.state.totalMinutosReproduzidos}</h1>
                                </div>
                                <h3 style={{ marginTop: '5px', color: 'lightgrey' }}>Número de minutos reproduzidos</h3>
                            </Paper>
                            <Paper className='data-card' style={{
                                position: 'relative',
                                width: '18%',
                                minWidth: '200px',
                                padding: '10px 20px',
                                color: 'grey',
                                textAlign: 'start',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                justifyContent: 'center'
                            }}>
                                <ImageIconBox style={{ position: 'absolute', top: '10px', right: '15px' }} src={dashedClockIcon}></ImageIconBox>
                                <div style={{ borderLeft: `3px ${palette.primary.main} solid`, padding: '5px 7px' }}>
                                    <h3 style={{ fontWeight: '500', paddingRight: '15px' }}>Média de minutos</h3>
                                    <h1 style={{ marginTop: '5px' }}>{this.state.mediaMinutos}</h1>
                                </div>
                                <h3 style={{ marginTop: '5px', color: 'lightgrey' }}>Média de minutos reproduzidos</h3>
                            </Paper>
                        </div>
                    </Grid>

                    {/* <Grid
                        item
                        lg={12}
                        md={12}
                        xl={12}
                        xs={12}
                    > */}
                    {/* <TableEpisodios listaEpisodios={this.state.episodiosNoPeriodo}></TableEpisodios> */}
                    {/* <LatestOrders /> */}
                    {/* </Grid> */}
                </Grid>
            </div>
        );
    }
} 